import Sortable from 'sortablejs'

/**
 * @param {Object} el - dom元素
 * @param {Object} sortTable - 排序列表
 * @param {Function} handleSort - 排序后回调函数
 */
export function createSortTable(el, sortTable, handleSort) {
  return Sortable.create(el, {
    animation: 150,
    delay: 0,
    handle: '.a-icon', // 句柄-点击指定class样式的对象时才能拖拽元素
    draggable: '.el-table__row', // 指定那些元素可以被拖拽
    onMove: ({dragged, related}) => {
      const oldRow = sortTable[dragged.rowIndex]
      const newRow = sortTable[related.rowIndex]
      if (oldRow.level !== newRow.level || oldRow.parentId !== newRow.parentId) {
        return false
      }
    },
    onEnd: ({ oldIndex, newIndex }) => {
      if (oldIndex === newIndex) {
        return
      }
      handleSort(oldIndex, newIndex)
    }
  })
}
